import { CheckCircle2 } from "lucide-react";

function Row({ label, value, ok, testid }) {
  return (
    <div className="flex items-center justify-between gap-3 py-2.5" data-testid={testid}>
      <span className="text-[13px] text-[#8a8a9e]">{label}</span>
      {ok ? (
        <span className="flex items-center gap-1.5 font-orbitron text-[12px] font-bold text-[#00ff88] tracking-wider">
          {value} <CheckCircle2 size={14} />
        </span>
      ) : (
        <span className="font-orbitron text-[12px] font-bold text-[#00f0ff] tracking-wider text-right">
          {value}
        </span>
      )}
    </div>
  );
}

export default function FreePreview({ preview }) {
  return (
    <div
      data-testid="free-preview-card"
      className="mt-6 rounded-2xl border border-[#00f0ff]/40 bg-[#00f0ff]/5 p-5 relative overflow-hidden"
    >
      <span className="absolute top-0 right-0 font-jetmono text-[9px] tracking-[0.2em] bg-[#00f0ff]/15 text-[#00f0ff] px-3 py-1 rounded-bl-lg">
        ANTEPRIMA GRATUITA
      </span>
      {preview.data_source === "demo" && (
        <span className="font-jetmono text-[9px] tracking-[0.15em] text-amber-300/90 block mb-2 max-w-[75%] leading-relaxed">
          MODALITÀ DEMO — CHIAVE API IN ATTESA DI ATTIVAZIONE
        </span>
      )}
      <div className="divide-y divide-white/5 mt-2">
        <Row
          testid="preview-vehicle-name"
          label="Veicolo Trovato"
          value={`${preview.brand} ${preview.model}`}
        />
        <Row testid="preview-registration" label="Anno Immatricolazione" value={preview.registration} />
        <Row testid="preview-status" label="Stato Registri" value="VERIFICATO" ok />
      </div>
    </div>
  );
}
